import { createFileRoute } from "@tanstack/react-router";
import TripsPage from "@/components/trips/trips-page";

function BrokerShipperTripsPage() {
  return (
    <TripsPage viewMode="shipper" brokerScope="partner" enableShipperFilter />
  );
}

export const Route = createFileRoute("/_app/trips/shipper")({
  component: BrokerShipperTripsPage,
});
